<template>
	<lcsj-dialog v-model="showDialog" ref="processInputDetailDialog" :title="'加工入库单详情 - ' + (detailData.inputStoreNo || '')" width="80%" append-to-body @close="closeDialog" cancel-text="关闭">
		<el-descriptions :column="3" border size="small" class="detail-desc">
			<el-descriptions-item label="入库单号">{{ detailData.inputStoreNo || "--" }}</el-descriptions-item>
			<el-descriptions-item label="入库类型">{{ detailData.inputTypeStr || "--" }}</el-descriptions-item>
			<el-descriptions-item label="来源采购单号">{{ detailData.purchaseNo || "--" }}</el-descriptions-item>
			<el-descriptions-item label="入库人">{{ detailData.inputUserName || "--" }}</el-descriptions-item>
			<el-descriptions-item label="入库时间">{{ detailData.inputDate || "--" }}</el-descriptions-item>
			<el-descriptions-item label="备注">{{ detailData.remark || "--" }}</el-descriptions-item>
		</el-descriptions>
		<div class="detail-block-title">入库明细</div>
		<el-table class="lcsj-data-table" :data="detailData.dtls || []" border size="small" style="width: 100%">
			<el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
			<el-table-column label="商品名称" min-width="200" align="center">
				<template #default="scope">{{ scope.row.goodsName || "--" }}</template>
			</el-table-column>
			<el-table-column label="球镜" width="80" align="center" prop="qiuJing"></el-table-column>
			<el-table-column label="柱镜" width="80" align="center" prop="zhuJing"></el-table-column>
			<el-table-column label="入库数量" width="100" align="center" prop="quantity"></el-table-column>
			<el-table-column label="备注" min-width="140" align="center">
				<template #default="scope">{{ scope.row.remark || "--" }}</template>
			</el-table-column>
		</el-table>
		
	</lcsj-dialog>
</template>

<script>
import { GetProcessInputStoreInfo } from "@/api/processApi.js";
export default {
	data() {
		return {
			showDialog: false,
			detailData: {}
		};
	},
	methods: {
		showSeeDetailDialog(row) {
			this.showDialog = true;
			GetProcessInputStoreInfo({ keyId: row.keyId })
				.then((res) => {
					if (res.code == 1) {
						this.detailData = res.data || {};
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		closeDialog() {
			this.showDialog = false;
			this.detailData = {};
		}
	}
};
</script>

<style scoped>
.detail-desc {
	margin-bottom: 12px;
}
.detail-block-title {
	margin: 10px 0;
	font-weight: 600;
}
</style>
